/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * guard component for the newest versions of create inquiry modal (>= 3)
 *
 *
 *
 * @author Andrey Dubov
 * @version 1.23.0
 * @since 1.23.0
 */

import { useSelector } from 'react-redux';

import { IOptionItemProps } from '@/main/components/common/Select/Select';
import FormFieldMultiSelect from '@/main/modules/form/components/FormFieldMultiSelect';
import { FormFieldMultiSelectInfinite } from '@/main/modules/form/components/FormFieldMultiSelectInfinite';
import FormFieldSelect from '@/main/modules/form/components/FormFieldSelect';
import { FormFieldSelectInfinite } from '@/main/modules/form/components/FormFieldSelectInfinite';
import { FeatureNameEnum } from '@/main/modules/role/constants/guard/guardConstants';
import { makeSelectIsFeatureWithVersionEnabled } from '@/main/pages/PageAuth/selectors/authSelectors';

import { inquiryApi } from '../../inquiryApi';
import { TAttributeDictionaryParams } from '../../types';

export type TCreateInquiryFormFieldSelect = {
    isMultiSelect?: boolean;
    dataName: string;
    name: string;
    onSelect: (args: IOptionItemProps[] | IOptionItemProps) => void;
    dictionary?: IOptionItemProps[];
    params: TAttributeDictionaryParams;
    errorKey?: string;
};

export const CreateInquiryFormFieldSelect = ({
    dictionary,
    params,
    isMultiSelect = false,
    ...rest
}: TCreateInquiryFormFieldSelect) => {
    const isInquiriesV4Enabled = useSelector(makeSelectIsFeatureWithVersionEnabled(FeatureNameEnum.INQUIRIES, 4));

    if (isInquiriesV4Enabled) {
        return (
            <>
                {isMultiSelect ? (
                    <FormFieldMultiSelectInfinite<TAttributeDictionaryParams>
                        fullWide
                        endpoint={inquiryApi.endpoints.postAttributeDictionary}
                        params={params}
                        placeholder=""
                        {...rest}
                    />
                ) : (
                    <FormFieldSelectInfinite<TAttributeDictionaryParams>
                        endpoint={inquiryApi.endpoints.postAttributeDictionary}
                        maxWidth="592px"
                        params={params}
                        placeholder=""
                        {...rest}
                    />
                )}
            </>
        );
    }
    return (
        <>
            {isMultiSelect ? (
                <FormFieldMultiSelect options={dictionary || []} placeholder="" {...rest} />
            ) : (
                <FormFieldSelect options={dictionary || []} placeholder="" {...rest} maxWidth="592px" />
            )}
        </>
    );
};
